import AccountsPage from './AccountsPage';
export default AccountsPage;